import { ArrowDownIcon } from "@phosphor-icons/react/dist/csr/ArrowDown";
import type { ReactNode } from "react";

export const GuideArticle = ({
  previewId,
  lead,
  children,
}: {
  previewId?: string;
  lead: ReactNode;
  children: ReactNode;
}) => (
  <div className="typeset typeset-document mt-4 [&>:first-child]:mt-0">
    {previewId && (
      <p>
        <a href={`#${previewId}`} className="inline-flex items-center gap-1">
          View the app preview
          <ArrowDownIcon aria-hidden className="size-3.5" />
        </a>
      </p>
    )}
    <p className="text-base">{lead}</p>
    {children}
  </div>
);
